import type { SearchEntityType } from '../../lib/dto';

/**
 * تسميات البحث العربية (§6.6). ترتيب المجموعات هو ترتيب المواصفة حرفيًا: مشاريع،
 * مهام، قيود اليومية، قرارات، التقاطات — والمظلات سادسًا لأن `search_all_v` يحملها.
 *
 * **قيد:** الأنواع الستة مرآة `SEARCH_ENTITY_TYPES` في `packages/domain`؛ نوع يظهر
 * من الخادم خارج القائمة يُعرض في مجموعته الخام بلا كسر (انظر `groupResults`).
 */

export const SEARCH_TYPE_ORDER: readonly SearchEntityType[] = [
  'project',
  'task',
  'entry',
  'decision',
  'capture',
  'venture',
];

/** عنوان المجموعة — جمع. */
export const SEARCH_TYPE_LABELS: Readonly<Record<SearchEntityType, string>> = {
  project: 'مشاريع',
  task: 'مهام',
  entry: 'قيود اليومية',
  decision: 'قرارات',
  capture: 'التقاطات',
  venture: 'مظلات',
};

/** شريحة الفلتر — مفرد ألطف على شريط الشرائح. */
export const SEARCH_TYPE_CHIP_LABELS: Readonly<Record<SearchEntityType, string>> = {
  project: 'مشروع',
  task: 'مهمة',
  entry: 'قيد',
  decision: 'قرار',
  capture: 'التقاط',
  venture: 'مظلة',
};

export function searchTypeLabel(type: string): string {
  return type in SEARCH_TYPE_LABELS ? SEARCH_TYPE_LABELS[type as SearchEntityType] : type;
}
